<template>
	<!-- 关于我们 -->
	<div class="about">
		<!-- top -->
		<headers/>
		<!-- 内容 -->
		<div class="common">
			<div class="banner">
			</div>
			<!-- 位置 -->
			<div class="public site">
				<span class="square"></span>
				<p>您的位置： 首页  <span>></span>  硬件设备</p>
			</div>
			<!-- 产品展示 -->
			<div class="contact">
				<p class="contactP">硬件设备</p>
				<p class="contactP2">Product display</p>
				<div class="contactList public">
					<div class="equipment">
						<ul class="clearfix">
							<li>
								<div class="equipment_item">
									<div class="equipment_cover"><img src="../../assets/images/product/product.jpg"></div>
									<div class="equipment_info">
										<h3>精致型车牌识别一体机</h3>
										<ul>
											<li>用于路侧停车图像视频识别</li>
											<li>占用空间小，易于安装维护</li>
											<li>费用低，识别率高</li>
										</ul>
									</div>
								</div>
							</li>
							<li>
								<div class="equipment_item">
									<div class="equipment_cover"><img src="../../assets/images/product/product2.jpg"></div>
									<div class="equipment_info">
										<h3豪华型车牌识别一体机</h3>
										<ul>
											<li>用于路侧停车图像视频识别</li>
											<li>占用空间小，易于安装维护</li>
											<li>费用低，识别率高</li>
										</ul>
									</div>
								</div>
							</li>
							<li>
								<div class="equipment_item">
									<div class="equipment_cover"><img src="../../assets/images/product/product3.jpg"></div>
									<div class="equipment_info">
										<h3>尊贵型车牌识别一体机</h3>
										<ul>
											<li>用于路侧停车图像视频识别</li>
											<li>占用空间小，易于安装维护</li>
											<li>费用低，识别率高</li>
										</ul>
									</div>
								</div>
							</li>
							<li>
								<div class="equipment_item">
									<div class="equipment_cover"><img src="../../assets/images/product/parking_equipment1_5.jpg"></div>
									<div class="equipment_info">
										<h3>低位雷达视频</h3>
										<ul>
											<li>用于路侧停车图像视频识别</li>
											<li>占用空间小，易于安装维护</li>
											<li>费用低，识别率高</li>
										</ul>
									</div>
								</div>
							</li>
							<li>
								<div class="equipment_item">
									<div class="equipment_cover">
										<img src="../../assets/images/product/parking_equipment1_1.jpg">
									</div>
									<div class="equipment_info">
										<h3>双枪机 枪球一体机</h3>
										<ul>
											<li>人工智能、自动识别车牌</li>
											<li>准确记录停车时间</li>
										</ul>
									</div>
								</div>
							</li>
							<li>
								<div class="equipment_item">
									<div class="equipment_cover">
										<img src="../../assets/images/product/parking_equipment1_8.jpg">
									</div>
								  <div class="equipment_info">
										<h3>违停球</h3>
										<ul>
											<li>360度无死角抓拍违章</li>
											<li>自动化、主动识别违章停车行为</li>
											<li>智能化、主动对目标进行超高清晰化锁定</li>
										</ul>
									</div>
								</div>
							</li>
							<li>
								<div class="equipment_item">
									<div class="equipment_cover"><img src="../../assets/images/product/parking_equipment1_4.jpg"></div>
									<div class="equipment_info">
										<h3>掌停车app</h3>
										<ul>
											<li>车位查找、车位导航</li>
											<li>车牌绑定、在线支付等</li>
										</ul>
									</div>
								</div>
							</li>
							<li>
								<div class="equipment_item">
									<div class="equipment_cover"><img src="../../assets/images/product/parking_equipment1_6.jpg"></div>
									<div class="equipment_info">
										<h3>车位诱导屏</h3>
										<ul>
											<li>通过网络接入平台管理中心，显示周边车位资源状况，引导车主停车</li>
										</ul>
									</div>
								</div>
							</li>
							<li>
								<div class="equipment_item">
									<div class="equipment_cover"><img src="../../assets/images/product/parking_equipment1_7.jpg"></div>
									<div class="equipment_info">
										<h3>PDA设备</h3>
										<ul>
											<li>管理员巡查终端</li>
											<li>接收车位异常提醒</li>
											<li>处理违章记录并拍照取证</li>
										</ul>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!-- bottom -->
		<footers></footers>
	</div>
</template>

<script>
	import headers from '@/components/header.vue'
	import footers from '@/components/footer.vue'
	export default{
		data(){
			return{
				
			}
		},
		methods:{
		  
		},
		components:{
			headers,footers
		}
	}
</script>
<style>
	/* 产品展示 */
	
		.equipment { background:#fff; overflow:hidden;}
	
		.equipment ul { margin:0 -15px;text-align: left;}
	
		.equipment li { float:left; width:33.333333%}
	
		.equipment_item  { margin:15px; border:1px solid #d9d9d9; -webkit-box-sizing:border-box; -moz-box-sizing:border-box; box-sizing:border-box}
	
		.equipment_cover { text-align:center; overflow:hidden; display:table-cell; vertical-align:middle; width:378px; height:270px; position:relative;}
	
		.equipment_cover img{ max-width:378px; max-height:270px; vertical-align:middle; -webkit-transition:all 0.3s linear; -moz-transition:all 0.3s linear; -o-transition:all 0.3s linear; -ms-transition:all 0.3s linear; transition:all 0.3s linear}
		
		.equipment_cover:hover img { -webkit-transform:scale(1.1); -moz-transform: scale(1.1); -o-transform:scale(1.1); -ms-transform:scale(1.1); transform:scale(1.1)}
	
		.wrap980 .equipment_cover img{ max-width:300px; max-height:180px;}
	
		.equipment_info { position:relative; height:135px; margin:0 20px 20px 20px; padding:20px 0; font-size:16px; color:#333; overflow:hidden; border-top:1px solid #ddd;}
	
		.equipment_info p { margin:0}
	
	
		.equipment li:hover .equipment_item { box-shadow:0 0px 20px rgba(102,102,102,.3); transition:transform .3s ease-in,box-shadow .3s ease-in}
	
		.equipment li:hover .equipment_cover img { -webkit-transform:scale(1.1); -moz-transform: scale(1.1); -o-transform:scale(1.1); -ms-transform:scale(1.1); transform:scale(1.1)}
	
	
	
		.equipment_info h3 { font-size:20px; width:100%;font-weight: normal;}
	
		.equipment_info h3 span { position:relative; top:-17px; padding:0 20px; background:#fff}
	
		.equipment_info ul { padding:10px 20px; overflow:hidden}
	
		.equipment_info li { float:left; width:100% !important; padding:3px 0 3px 25px; color:#666; list-style:none; background:url(../../assets/images/icon_circle.png) no-repeat left 10px; -webkit-box-sizing:border-box; -moz-box-sizing:border-box; box-sizing:border-box}
	
		.equipment .equipment1 { width:66.666667%}
	
		.equipment .equipment1 .equipment_cover { padding:20px 20px 0 20px}
	
		.equipment .equipment1 .equipment_cover div { float:left; width:50%}
	
		.equipment .equipment1 .equipment_cover img { width:200px; height:140px}
	
		.equipment .equipment1 .equipment_info { height:155px}
	
		.equipment .equipment1 .equipment_info h2 { width:100%; padding:10px 0; font-size:20px; border-bottom:1px solid #ddd; margin:0; text-align:center; overflow:hidden}
	
		.equipment .equipment1 .equipment_info h2 span { float:left; width:50% !important; text-align:center}
	
		.equipment .equipment1 .equipment_info ul { margin:0 auto; margin-top:11px; width:220px; text-align:center; overflow:hidden}
	
		.equipment .equipment1 .equipment_info li { text-align:left}

</style>
<style lang="scss" scoped="scoped">
	.banner{
		width: 100%;
		height:540px;
		margin: 0 auto;
		vertical-align: middle;
		position: relative;
		background: url(../../assets/images/product.png) center no-repeat;
		background-size:100% 100%;
		text-align: center;
	}
	.public{
		width: 1200px;
		margin: 0 auto;
	}
	.site{
		height: 36px;
		display: flex;
		flex-direction: row;
		align-items: center;
		text-align: left;
		font-size:16px;
		color:#333;
		margin: 30px auto;
		border-bottom:1px dashed #ccc;
		.square{
			display: inline-block;
			width: 10px;
			height: 20px;
			background: #000;
			margin-right: 10px;
		}
		p{
			span{
				padding: 0 5px;
			}
		}
	}
	.contact{
		.contactP{
			margin-top: 20px;
			padding: 10px 0;
			font-size: 28px;
			font-weight: bold;
		}
		.contactP2{
			margin-bottom: 20px;
			text-transform:uppercase;
		}
		.contactList{
			display: flex;
			flex-direction: row;
			width
			.item{
				width:33%;
				margin-right:0.5;
				margin-bottom:40px;
				&:nth-child(4n){
					margin-right: 0;
				}
				.itemImg{
					height: 470px;
					padding: 10px;
					border: 1px solid #ccc;
					text-align: center;
					vertical-align: middle;
					img{
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}
				.itemFont{
					height: 50px;
					line-height: 50px;
					text-align: center;
					background: #f0f0f0;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/product/product.vue